// @generated by protoc-gen-es v2.10.2 with parameter "target=ts+js"
// @generated from file lease/merchant/v1/api.proto (package lease.merchant.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_field_behavior } from "../google/api/field_behavior_pb";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_lease_common_v1_types } from "../common/v1/types_pb";

/**
 * Describes the file lease/merchant/v1/api.proto.
 */
export const file_lease_merchant_v1_api = /*@__PURE__*/
  fileDesc("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", [file_google_api_field_behavior, file_google_protobuf_timestamp, file_lease_common_v1_types]);

/**
 * Describes the message lease.merchant.v1.RefundRequest.
 * Use `create(RefundRequestSchema)` to create a new message.
 */
export const RefundRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 0);

/**
 * Describes the message lease.merchant.v1.RefundResponse.
 * Use `create(RefundResponseSchema)` to create a new message.
 */
export const RefundResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 1);

/**
 * Describes the message lease.merchant.v1.ListCustomersRequest.
 * Use `create(ListCustomersRequestSchema)` to create a new message.
 */
export const ListCustomersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 2);

/**
 * Describes the message lease.merchant.v1.ListCustomersResponse.
 * Use `create(ListCustomersResponseSchema)` to create a new message.
 */
export const ListCustomersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 3);

/**
 * Describes the message lease.merchant.v1.Customer.
 * Use `create(CustomerSchema)` to create a new message.
 */
export const CustomerSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 4);

/**
 * Describes the message lease.merchant.v1.ListProductsRequest.
 * Use `create(ListProductsRequestSchema)` to create a new message.
 */
export const ListProductsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 5);

/**
 * Describes the message lease.merchant.v1.Product.
 * Use `create(ProductSchema)` to create a new message.
 */
export const ProductSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 6);

/**
 * Describes the message lease.merchant.v1.ListProductsResponse.
 * Use `create(ListProductsResponseSchema)` to create a new message.
 */
export const ListProductsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 7);

/**
 * Describes the message lease.merchant.v1.ListProductTrackableItemsRequest.
 * Use `create(ListProductTrackableItemsRequestSchema)` to create a new message.
 */
export const ListProductTrackableItemsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 8);

/**
 * Describes the message lease.merchant.v1.TrackableItemLocation.
 * Use `create(TrackableItemLocationSchema)` to create a new message.
 */
export const TrackableItemLocationSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 9);

/**
 * Describes the message lease.merchant.v1.TrackableItem.
 * Use `create(TrackableItemSchema)` to create a new message.
 */
export const TrackableItemSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 10);

/**
 * Describes the message lease.merchant.v1.ListProductTrackableItemsResponse.
 * Use `create(ListProductTrackableItemsResponseSchema)` to create a new message.
 */
export const ListProductTrackableItemsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 11);

/**
 * Describes the message lease.merchant.v1.UpdateProductRequest.
 * Use `create(UpdateProductRequestSchema)` to create a new message.
 */
export const UpdateProductRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 12);

/**
 * Describes the message lease.merchant.v1.UpdateProductResponse.
 * Use `create(UpdateProductResponseSchema)` to create a new message.
 */
export const UpdateProductResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 13);

/**
 * Describes the message lease.merchant.v1.CreateProductRequest.
 * Use `create(CreateProductRequestSchema)` to create a new message.
 */
export const CreateProductRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 14);

/**
 * Describes the message lease.merchant.v1.CreateProductResponse.
 * Use `create(CreateProductResponseSchema)` to create a new message.
 */
export const CreateProductResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 15);

/**
 * Describes the message lease.merchant.v1.CreateTrackableItemRequest.
 * Use `create(CreateTrackableItemRequestSchema)` to create a new message.
 */
export const CreateTrackableItemRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 16);

/**
 * Describes the message lease.merchant.v1.CreateTrackableItemResponse.
 * Use `create(CreateTrackableItemResponseSchema)` to create a new message.
 */
export const CreateTrackableItemResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 17);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemRequest.
 * Use `create(UpdateTrackableItemRequestSchema)` to create a new message.
 */
export const UpdateTrackableItemRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 18);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemResponse.
 * Use `create(UpdateTrackableItemResponseSchema)` to create a new message.
 */
export const UpdateTrackableItemResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 19);

/**
 * Describes the message lease.merchant.v1.ListMachinesRequest.
 * Use `create(ListMachinesRequestSchema)` to create a new message.
 */
export const ListMachinesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 20);

/**
 * Describes the message lease.merchant.v1.MachineInfo.
 * Use `create(MachineInfoSchema)` to create a new message.
 */
export const MachineInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 21);

/**
 * Describes the message lease.merchant.v1.ListMachinesResponse.
 * Use `create(ListMachinesResponseSchema)` to create a new message.
 */
export const ListMachinesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 22);

/**
 * Describes the message lease.merchant.v1.ListMachineProductMapsRequest.
 * Use `create(ListMachineProductMapsRequestSchema)` to create a new message.
 */
export const ListMachineProductMapsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 23);

/**
 * Describes the message lease.merchant.v1.ProductMap.
 * Use `create(ProductMapSchema)` to create a new message.
 */
export const ProductMapSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 24);

/**
 * Describes the message lease.merchant.v1.ListMachineProductMapsResponse.
 * Use `create(ListMachineProductMapsResponseSchema)` to create a new message.
 */
export const ListMachineProductMapsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 25);

/**
 * Describes the message lease.merchant.v1.ListOrdersRequest.
 * Use `create(ListOrdersRequestSchema)` to create a new message.
 */
export const ListOrdersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 26);

/**
 * Describes the message lease.merchant.v1.Order.
 * Use `create(OrderSchema)` to create a new message.
 */
export const OrderSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 27);

/**
 * Describes the message lease.merchant.v1.RefundStatus.
 * Use `create(RefundStatusSchema)` to create a new message.
 */
export const RefundStatusSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 28);

/**
 * Describes the message lease.merchant.v1.ListOrdersResponse.
 * Use `create(ListOrdersResponseSchema)` to create a new message.
 */
export const ListOrdersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 29);

/**
 * Describes the message lease.merchant.v1.ListCustomerOrdersRequest.
 * Use `create(ListCustomerOrdersRequestSchema)` to create a new message.
 */
export const ListCustomerOrdersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 30);

/**
 * Describes the message lease.merchant.v1.ListCustomerOrdersResponse.
 * Use `create(ListCustomerOrdersResponseSchema)` to create a new message.
 */
export const ListCustomerOrdersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 31);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemStateRequest.
 * Use `create(UpdateTrackableItemStateRequestSchema)` to create a new message.
 */
export const UpdateTrackableItemStateRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 32);

/**
 * Describes the message lease.merchant.v1.UpdateTrackableItemStateResponse.
 * Use `create(UpdateTrackableItemStateResponseSchema)` to create a new message.
 */
export const UpdateTrackableItemStateResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 33);

/**
 * Describes the message lease.merchant.v1.OpenDoorsRequest.
 * Use `create(OpenDoorsRequestSchema)` to create a new message.
 */
export const OpenDoorsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 34);

/**
 * Describes the message lease.merchant.v1.OpenDoorsResponse.
 * Use `create(OpenDoorsResponseSchema)` to create a new message.
 */
export const OpenDoorsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 35);

/**
 * Describes the message lease.merchant.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 36);

/**
 * Describes the message lease.merchant.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 37);

/**
 * Describes the message lease.merchant.v1.GetStatsRequest.
 * Use `create(GetStatsRequestSchema)` to create a new message.
 */
export const GetStatsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 38);

/**
 * Describes the message lease.merchant.v1.GetStatsResponse.
 * Use `create(GetStatsResponseSchema)` to create a new message.
 */
export const GetStatsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 39);

/**
 * Describes the message lease.merchant.v1.Stats.
 * Use `create(StatsSchema)` to create a new message.
 */
export const StatsSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 40);

/**
 * Describes the message lease.merchant.v1.PaymentInformation.
 * Use `create(PaymentInformationSchema)` to create a new message.
 */
export const PaymentInformationSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 41);

/**
 * Describes the message lease.merchant.v1.GetMyOrganizationInfoRequest.
 * Use `create(GetMyOrganizationInfoRequestSchema)` to create a new message.
 */
export const GetMyOrganizationInfoRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 42);

/**
 * Describes the message lease.merchant.v1.OrganizationInfo.
 * Use `create(OrganizationInfoSchema)` to create a new message.
 */
export const OrganizationInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 43);

/**
 * Describes the message lease.merchant.v1.GetMyOrganizationInfoResponse.
 * Use `create(GetMyOrganizationInfoResponseSchema)` to create a new message.
 */
export const GetMyOrganizationInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 44);

/**
 * Describes the message lease.merchant.v1.UpdateOrganizationInfoRequest.
 * Use `create(UpdateOrganizationInfoRequestSchema)` to create a new message.
 */
export const UpdateOrganizationInfoRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 45);

/**
 * Describes the message lease.merchant.v1.UpdateOrganizationInfoResponse.
 * Use `create(UpdateOrganizationInfoResponseSchema)` to create a new message.
 */
export const UpdateOrganizationInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 46);

/**
 * Describes the message lease.merchant.v1.GetMyInfoRequest.
 * Use `create(GetMyInfoRequestSchema)` to create a new message.
 */
export const GetMyInfoRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 47);

/**
 * Describes the message lease.merchant.v1.UserInfo.
 * Use `create(UserInfoSchema)` to create a new message.
 */
export const UserInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 48);

/**
 * Describes the message lease.merchant.v1.GetMyInfoResponse.
 * Use `create(GetMyInfoResponseSchema)` to create a new message.
 */
export const GetMyInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 49);

/**
 * Describes the message lease.merchant.v1.UpdateVendingMachineRequest.
 * Use `create(UpdateVendingMachineRequestSchema)` to create a new message.
 */
export const UpdateVendingMachineRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 50);

/**
 * Describes the message lease.merchant.v1.UpdateVendingMachineResponse.
 * Use `create(UpdateVendingMachineResponseSchema)` to create a new message.
 */
export const UpdateVendingMachineResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 51);

/**
 * Describes the message lease.merchant.v1.GetUploadUrlRequest.
 * Use `create(GetUploadUrlRequestSchema)` to create a new message.
 */
export const GetUploadUrlRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 52);

/**
 * Describes the message lease.merchant.v1.GetUploadUrlResponse.
 * Use `create(GetUploadUrlResponseSchema)` to create a new message.
 */
export const GetUploadUrlResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 53);

/**
 * Describes the message lease.merchant.v1.UpdateProductMapRequest.
 * Use `create(UpdateProductMapRequestSchema)` to create a new message.
 */
export const UpdateProductMapRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 54);

/**
 * Describes the message lease.merchant.v1.UpdateProductMapResponse.
 * Use `create(UpdateProductMapResponseSchema)` to create a new message.
 */
export const UpdateProductMapResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 55);

/**
 * Describes the message lease.merchant.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 56);

/**
 * Describes the message lease.merchant.v1.SendEventToMachineRequest.
 * Use `create(SendEventToMachineRequestSchema)` to create a new message.
 */
export const SendEventToMachineRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 57);

/**
 * Describes the message lease.merchant.v1.SendEventToMachineResponse.
 * Use `create(SendEventToMachineResponseSchema)` to create a new message.
 */
export const SendEventToMachineResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 58);

/**
 * Describes the message lease.merchant.v1.OrderDailySummariesRequest.
 * Use `create(OrderDailySummariesRequestSchema)` to create a new message.
 */
export const OrderDailySummariesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 59);

/**
 * Describes the message lease.merchant.v1.OrderDailySummary.
 * Use `create(OrderDailySummarySchema)` to create a new message.
 */
export const OrderDailySummarySchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 60);

/**
 * Describes the message lease.merchant.v1.OrderDailySummariesResponse.
 * Use `create(OrderDailySummariesResponseSchema)` to create a new message.
 */
export const OrderDailySummariesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 61);

/**
 * Describes the message lease.merchant.v1.ListCellOrdersRequest.
 * Use `create(ListCellOrdersRequestSchema)` to create a new message.
 */
export const ListCellOrdersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 62);

/**
 * Describes the message lease.merchant.v1.ListCellOrdersResponse.
 * Use `create(ListCellOrdersResponseSchema)` to create a new message.
 */
export const ListCellOrdersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 63);

/**
 * Describes the message lease.merchant.v1.GetCustomerAuthLogsRequest.
 * Use `create(GetCustomerAuthLogsRequestSchema)` to create a new message.
 */
export const GetCustomerAuthLogsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 64);

/**
 * Describes the message lease.merchant.v1.AuthLog.
 * Use `create(AuthLogSchema)` to create a new message.
 */
export const AuthLogSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 65);

/**
 * Describes the message lease.merchant.v1.GetCustomerAuthLogsResponse.
 * Use `create(GetCustomerAuthLogsResponseSchema)` to create a new message.
 */
export const GetCustomerAuthLogsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 66);

/**
 * Describes the message lease.merchant.v1.GetCustomerSMSDeliveryStatusRequest.
 * Use `create(GetCustomerSMSDeliveryStatusRequestSchema)` to create a new message.
 */
export const GetCustomerSMSDeliveryStatusRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 67);

/**
 * Describes the message lease.merchant.v1.SMSDeliveryStatus.
 * Use `create(SMSDeliveryStatusSchema)` to create a new message.
 */
export const SMSDeliveryStatusSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 68);

/**
 * Describes the message lease.merchant.v1.GetCustomerSMSDeliveryStatusResponse.
 * Use `create(GetCustomerSMSDeliveryStatusResponseSchema)` to create a new message.
 */
export const GetCustomerSMSDeliveryStatusResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 69);

/**
 * Describes the message lease.merchant.v1.VenueAccessCodeConfig.
 * Use `create(VenueAccessCodeConfigSchema)` to create a new message.
 */
export const VenueAccessCodeConfigSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 70);

/**
 * Describes the message lease.merchant.v1.VenueAccessCode.
 * Use `create(VenueAccessCodeSchema)` to create a new message.
 */
export const VenueAccessCodeSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 71);

/**
 * Describes the message lease.merchant.v1.ListVenueAccessCodesRequest.
 * Use `create(ListVenueAccessCodesRequestSchema)` to create a new message.
 */
export const ListVenueAccessCodesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 72);

/**
 * Describes the message lease.merchant.v1.ListVenueAccessCodesResponse.
 * Use `create(ListVenueAccessCodesResponseSchema)` to create a new message.
 */
export const ListVenueAccessCodesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 73);

/**
 * Describes the message lease.merchant.v1.CreateVenueAccessCodesRequest.
 * Use `create(CreateVenueAccessCodesRequestSchema)` to create a new message.
 */
export const CreateVenueAccessCodesRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 74);

/**
 * Describes the message lease.merchant.v1.CreateVenueAccessCodesResponse.
 * Use `create(CreateVenueAccessCodesResponseSchema)` to create a new message.
 */
export const CreateVenueAccessCodesResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 75);

/**
 * Describes the message lease.merchant.v1.DeleteVenueAccessCodeRequest.
 * Use `create(DeleteVenueAccessCodeRequestSchema)` to create a new message.
 */
export const DeleteVenueAccessCodeRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 76);

/**
 * Describes the message lease.merchant.v1.DeleteVenueAccessCodeResponse.
 * Use `create(DeleteVenueAccessCodeResponseSchema)` to create a new message.
 */
export const DeleteVenueAccessCodeResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 77);

/**
 * Describes the message lease.merchant.v1.GetVenueAccessCodeUsageRequest.
 * Use `create(GetVenueAccessCodeUsageRequestSchema)` to create a new message.
 */
export const GetVenueAccessCodeUsageRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 78);

/**
 * Describes the message lease.merchant.v1.VenueAccessCodeUsageStats.
 * Use `create(VenueAccessCodeUsageStatsSchema)` to create a new message.
 */
export const VenueAccessCodeUsageStatsSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 79);

/**
 * Describes the message lease.merchant.v1.VenueAccessCodeUsage.
 * Use `create(VenueAccessCodeUsageSchema)` to create a new message.
 */
export const VenueAccessCodeUsageSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 80);

/**
 * Describes the message lease.merchant.v1.GetVenueAccessCodeUsageResponse.
 * Use `create(GetVenueAccessCodeUsageResponseSchema)` to create a new message.
 */
export const GetVenueAccessCodeUsageResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 81);

/**
 * Describes the message lease.merchant.v1.AuthConfiguration.
 * Use `create(AuthConfigurationSchema)` to create a new message.
 */
export const AuthConfigurationSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 82);

/**
 * Describes the message lease.merchant.v1.GetAuthConfigurationRequest.
 * Use `create(GetAuthConfigurationRequestSchema)` to create a new message.
 */
export const GetAuthConfigurationRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 83);

/**
 * Describes the message lease.merchant.v1.GetAuthConfigurationResponse.
 * Use `create(GetAuthConfigurationResponseSchema)` to create a new message.
 */
export const GetAuthConfigurationResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 84);

/**
 * Describes the message lease.merchant.v1.UpdateAuthConfigurationRequest.
 * Use `create(UpdateAuthConfigurationRequestSchema)` to create a new message.
 */
export const UpdateAuthConfigurationRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 85);

/**
 * Describes the message lease.merchant.v1.UpdateAuthConfigurationResponse.
 * Use `create(UpdateAuthConfigurationResponseSchema)` to create a new message.
 */
export const UpdateAuthConfigurationResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 86);

/**
 * Describes the message lease.merchant.v1.ListMachineActuatorsRequest.
 * Use `create(ListMachineActuatorsRequestSchema)` to create a new message.
 */
export const ListMachineActuatorsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 87);

/**
 * Describes the message lease.merchant.v1.ActuatorInfo.
 * Use `create(ActuatorInfoSchema)` to create a new message.
 */
export const ActuatorInfoSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 88);

/**
 * Describes the message lease.merchant.v1.ListMachineActuatorsResponse.
 * Use `create(ListMachineActuatorsResponseSchema)` to create a new message.
 */
export const ListMachineActuatorsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 89);

/**
 * Describes the message lease.merchant.v1.UpdateMachineActuatorRequest.
 * Use `create(UpdateMachineActuatorRequestSchema)` to create a new message.
 */
export const UpdateMachineActuatorRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 90);

/**
 * Describes the message lease.merchant.v1.UpdateMachineActuatorResponse.
 * Use `create(UpdateMachineActuatorResponseSchema)` to create a new message.
 */
export const UpdateMachineActuatorResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 91);

/**
 * Describes the message lease.merchant.v1.CreateMachineActuatorRequest.
 * Use `create(CreateMachineActuatorRequestSchema)` to create a new message.
 */
export const CreateMachineActuatorRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 92);

/**
 * Describes the message lease.merchant.v1.CreateMachineActuatorResponse.
 * Use `create(CreateMachineActuatorResponseSchema)` to create a new message.
 */
export const CreateMachineActuatorResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 93);

/**
 * Describes the message lease.merchant.v1.DeleteMachineActuatorRequest.
 * Use `create(DeleteMachineActuatorRequestSchema)` to create a new message.
 */
export const DeleteMachineActuatorRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 94);

/**
 * Describes the message lease.merchant.v1.DeleteMachineActuatorResponse.
 * Use `create(DeleteMachineActuatorResponseSchema)` to create a new message.
 */
export const DeleteMachineActuatorResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 95);

/**
 * Describes the message lease.merchant.v1.GetDoorStatusHistoryRequest.
 * Use `create(GetDoorStatusHistoryRequestSchema)` to create a new message.
 */
export const GetDoorStatusHistoryRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 96);

/**
 * Describes the message lease.merchant.v1.GetDoorStatusHistoryResponse.
 * Use `create(GetDoorStatusHistoryResponseSchema)` to create a new message.
 */
export const GetDoorStatusHistoryResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 97);

/**
 * Describes the message lease.merchant.v1.DoorStatusHistoryEntry.
 * Use `create(DoorStatusHistoryEntrySchema)` to create a new message.
 */
export const DoorStatusHistoryEntrySchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 98);

/**
 * Describes the message lease.merchant.v1.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 99);

/**
 * Describes the message lease.merchant.v1.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 100);

/**
 * Describes the message lease.merchant.v1.UpdateUserStatusRequest.
 * Use `create(UpdateUserStatusRequestSchema)` to create a new message.
 */
export const UpdateUserStatusRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 101);

/**
 * Describes the message lease.merchant.v1.UpdateUserStatusResponse.
 * Use `create(UpdateUserStatusResponseSchema)` to create a new message.
 */
export const UpdateUserStatusResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 102);

/**
 * Describes the message lease.merchant.v1.ResetUserPasswordRequest.
 * Use `create(ResetUserPasswordRequestSchema)` to create a new message.
 */
export const ResetUserPasswordRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 103);

/**
 * Describes the message lease.merchant.v1.ResetUserPasswordResponse.
 * Use `create(ResetUserPasswordResponseSchema)` to create a new message.
 */
export const ResetUserPasswordResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 104);

/**
 * Describes the message lease.merchant.v1.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 105);

/**
 * Describes the message lease.merchant.v1.CreateUserResponse.
 * Use `create(CreateUserResponseSchema)` to create a new message.
 */
export const CreateUserResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 106);

/**
 * Describes the message lease.merchant.v1.RequestPasswordResetRequest.
 * Use `create(RequestPasswordResetRequestSchema)` to create a new message.
 */
export const RequestPasswordResetRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 107);

/**
 * Describes the message lease.merchant.v1.RequestPasswordResetResponse.
 * Use `create(RequestPasswordResetResponseSchema)` to create a new message.
 */
export const RequestPasswordResetResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 108);

/**
 * Describes the message lease.merchant.v1.ResetPasswordWithTokenRequest.
 * Use `create(ResetPasswordWithTokenRequestSchema)` to create a new message.
 */
export const ResetPasswordWithTokenRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 109);

/**
 * Describes the message lease.merchant.v1.ResetPasswordWithTokenResponse.
 * Use `create(ResetPasswordWithTokenResponseSchema)` to create a new message.
 */
export const ResetPasswordWithTokenResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 110);

/**
 * Describes the message lease.merchant.v1.ChangePasswordRequest.
 * Use `create(ChangePasswordRequestSchema)` to create a new message.
 */
export const ChangePasswordRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 111);

/**
 * Describes the message lease.merchant.v1.ChangePasswordResponse.
 * Use `create(ChangePasswordResponseSchema)` to create a new message.
 */
export const ChangePasswordResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 112);

/**
 * Describes the message lease.merchant.v1.AuditLog.
 * Use `create(AuditLogSchema)` to create a new message.
 */
export const AuditLogSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 113);

/**
 * Describes the message lease.merchant.v1.ListAuditLogsRequest.
 * Use `create(ListAuditLogsRequestSchema)` to create a new message.
 */
export const ListAuditLogsRequestSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 114);

/**
 * Describes the message lease.merchant.v1.ListAuditLogsResponse.
 * Use `create(ListAuditLogsResponseSchema)` to create a new message.
 */
export const ListAuditLogsResponseSchema = /*@__PURE__*/
  messageDesc(file_lease_merchant_v1_api, 115);

/**
 * Describes the enum lease.merchant.v1.TrackableItemState.
 */
export const TrackableItemStateSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 0);

/**
 * @generated from enum lease.merchant.v1.TrackableItemState
 */
export const TrackableItemState = /*@__PURE__*/
  tsEnum(TrackableItemStateSchema);

/**
 * Describes the enum lease.merchant.v1.OrderStatus.
 */
export const OrderStatusSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 1);

/**
 * @generated from enum lease.merchant.v1.OrderStatus
 */
export const OrderStatus = /*@__PURE__*/
  tsEnum(OrderStatusSchema);

/**
 * Describes the enum lease.merchant.v1.NotifyCustomerToCloseDoorMethod.
 */
export const NotifyCustomerToCloseDoorMethodSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 2);

/**
 * @generated from enum lease.merchant.v1.NotifyCustomerToCloseDoorMethod
 */
export const NotifyCustomerToCloseDoorMethod = /*@__PURE__*/
  tsEnum(NotifyCustomerToCloseDoorMethodSchema);

/**
 * Describes the enum lease.merchant.v1.UserStatus.
 */
export const UserStatusSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 3);

/**
 * UserStatus defines the status of an admin user account
 *
 * @generated from enum lease.merchant.v1.UserStatus
 */
export const UserStatus = /*@__PURE__*/
  tsEnum(UserStatusSchema);

/**
 * Describes the enum lease.merchant.v1.EventType.
 */
export const EventTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 4);

/**
 * @generated from enum lease.merchant.v1.EventType
 */
export const EventType = /*@__PURE__*/
  tsEnum(EventTypeSchema);

/**
 * Describes the enum lease.merchant.v1.VenueAccessCodeValidationType.
 */
export const VenueAccessCodeValidationTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 5);

/**
 * VenueAccessCodeValidationType defines how venue access codes are validated
 *
 * @generated from enum lease.merchant.v1.VenueAccessCodeValidationType
 */
export const VenueAccessCodeValidationType = /*@__PURE__*/
  tsEnum(VenueAccessCodeValidationTypeSchema);

/**
 * Describes the enum lease.merchant.v1.VenueAccessCodeCharacterType.
 */
export const VenueAccessCodeCharacterTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 6);

/**
 * VenueAccessCodeCharacterType defines allowed characters in venue access codes
 *
 * @generated from enum lease.merchant.v1.VenueAccessCodeCharacterType
 */
export const VenueAccessCodeCharacterType = /*@__PURE__*/
  tsEnum(VenueAccessCodeCharacterTypeSchema);

/**
 * Describes the enum lease.merchant.v1.ActuatorType.
 */
export const ActuatorTypeSchema = /*@__PURE__*/
  enumDesc(file_lease_merchant_v1_api, 7);

/**
 * ActuatorType represents the type of actuator/slave device
 *
 * @generated from enum lease.merchant.v1.ActuatorType
 */
export const ActuatorType = /*@__PURE__*/
  tsEnum(ActuatorTypeSchema);

/**
 * @generated from service lease.merchant.v1.AuthService
 */
export const AuthService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 0);

/**
 * @generated from service lease.merchant.v1.CustomerService
 */
export const CustomerService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 1);

/**
 * @generated from service lease.merchant.v1.ProductService
 */
export const ProductService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 2);

/**
 * @generated from service lease.merchant.v1.MachineService
 */
export const MachineService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 3);

/**
 * @generated from service lease.merchant.v1.OrderService
 */
export const OrderService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 4);

/**
 * @generated from service lease.merchant.v1.OrganizationService
 */
export const OrganizationService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 5);

/**
 * @generated from service lease.merchant.v1.VenueAccessCodeService
 */
export const VenueAccessCodeService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 6);

/**
 * @generated from service lease.merchant.v1.UserService
 */
export const UserService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 7);

/**
 * @generated from service lease.merchant.v1.AuditLogService
 */
export const AuditLogService = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 8);

/**
 * @generated from service lease.merchant.v1.S3Service
 */
export const S3Service = /*@__PURE__*/
  serviceDesc(file_lease_merchant_v1_api, 9);

